import { observer } from 'mobx-react-lite'
import { PresetCard, PresetGrid } from 'shared/Preset'
import { type IAICallingType } from 'entities/AICalling/api/types'
import { CallingTemplates } from 'pages/chatbot/config'

import styles from './styles.module.scss'

type ICallingContentProps = {
  selectedType: IAICallingType
  onSelectType: (type: IAICallingType) => void
}

export const CallingContent = observer(({ selectedType, onSelectType }: ICallingContentProps) => (
  <PresetGrid className={styles.presetGrid}>
    {CallingTemplates.map((template) => (
      <PresetCard
        key={template.type}
        icon={template.icon}
        name={template.name}
        description={template.description}
        selected={selectedType === template.type}
        onClick={() => onSelectType(template.type)}
      />
    ))}
  </PresetGrid>
))
